import $ from "jquery";

const loanAccordion = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-ShowHideElement",
      target: "#iframe-loan",
    };

    if ($(el.button).length === 0) return;

    $(() => {
      $(el.target).hide()
      $(document).on('click', el.button, function () {
        $(el.target).slideToggle()
        $(this).find('.SearchLoanTop__TextRight__Icon').toggleClass('open')
        $(this).find('.SearchLoanTop').toggleClass('open')
      })
    });
  };

  init();
};

try {
  loanAccordion();
} catch (error) {
  console.error("loanAccordion: ", loanAccordion, error);
}
